// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"636":"fcddfe9b29ca496097fd","764":"f82785eb4df85ec64ac7"}[chunkId] + ".js";
};